import { useService } from '~/services/service.base';
import { ServiceCommunity } from '~/services/service.community';
import { ServiceBookCover } from '~/services/service.book.cover';
import { ServiceBookContent } from '~/services/service.book.content';
import { ServiceMediaViewer } from '~/services/service.media.viewer';
import { ServiceFileSaver } from '~/services/service.file.saver';
import { useCallback } from 'react';
import { ServiceConfig } from '~/services/service.config';
export const useActions = () => {
    const communityService = useService(ServiceCommunity);
    const booksCoverService = useService(ServiceBookCover);
    const serviceBookContent = useService(ServiceBookContent);
    const serviceMediaViewer = useService(ServiceMediaViewer);
    const serviceFileSaver = useService(ServiceFileSaver);
    const openBookHandler = useCallback(() => {
        booksCoverService.openContentService.handleOpen();
    }, [booksCoverService.openContentService]);
    const closeBookContentHandler = useCallback(() => {
        booksCoverService.openContentService.handleClose();
    }, [booksCoverService.openContentService]);
    const clickBySectionHandler = useCallback((section) => {
        booksCoverService.updateSheetNavigationData(section.id);
        booksCoverService.openContentService.handleClose();
        booksCoverService.openSectionService.handleOpen();
        serviceBookContent.getBookContent(communityService.currentCommunity.id, section.albumId, section.id);
    }, [booksCoverService, communityService.currentCommunity.id, serviceBookContent]);
    const changeSectionHandler = useCallback((sectionId, bookId) => {
        if (sectionId) {
            booksCoverService.updateSheetNavigationData(sectionId);
            serviceBookContent.getBookContent(communityService.currentCommunity.id, bookId, sectionId);
        }
    }, [booksCoverService, communityService.currentCommunity.id, serviceBookContent]);
    const clickByImageHandler = useCallback((item) => {
        serviceMediaViewer.setOpenedItem(item);
        serviceMediaViewer.mediaViewOpenService.handleOpen();
    }, [serviceMediaViewer]);
    const downloadImageHandler = useCallback((item) => {
        serviceFileSaver.save(item.fileLink || item.img, item.name);
    }, [serviceFileSaver]);
    const closeImageHandler = useCallback(() => {
        serviceMediaViewer.mediaViewOpenService.handleClose();
    }, [serviceMediaViewer.mediaViewOpenService]);
    const serviceConfig = useService(ServiceConfig);
    return {
        serviceConfig,
        closeBookContentHandler,
        closeImageHandler,
        downloadImageHandler,
        clickBySectionHandler,
        clickByImageHandler,
        openBookHandler,
        changeSectionHandler,
        booksCoverService,
        serviceBookContent,
        communityService,
    };
};
